import { LAYOUT } from '@admin/router/constant'

const GmpActivityRouter = {
  path: '/gmp',
  name: 'GmpActivity',
  component: LAYOUT,
  children: [
    // {
    //   path: '/gmp/activity/productActivity',
    //   name: 'GmpActivityProductActivity',
    //   component: () => import('@admin/views/gmp/activityManagement/productActivity/index.vue'),
    //   meta: {
    //     title: '商品活动',
    //   },
    // },
    {
      path: '/gmp/activity/orderPromotion',
      name: 'GmpActivityOrderPromotion',
      component: () => import('@admin/views/gmp/activityManagement/orderPromotion/list/_index.vue'),
      meta: {
        title: '促单活动',
      },
    },
    {
      path: '/gmp/activity/orderPromotionConfig',
      name: 'GmpActivityOrderPromotionConfig',
      component: () =>
        import('@admin/views/gmp/activityManagement/orderPromotion/config/index.vue'),
      meta: {
        title: '促单活动配置',
      },
    },
    {
      path: '/gmp/activity/productActivityConfig',
      name: 'GmpProductActivityConfigList',
      component: () => import('@admin/views/gmp/productActivity/productActivityConfig/_index.vue'),
      meta: {
        title: '单品折扣活动配置',
      },
    },
    {
      path: '/gmp/activity/productActivityConfigDetail',
      name: 'GmpProductActivityConfigDetail',
      component: () => import('@admin/views/gmp/productActivity/productActivityConfig/detail.vue'),
      meta: {
        title: '单品折扣活动配置详情',
      },
    },
  ],
}

export default GmpActivityRouter
